<template>
  <div class="receipt-list">
    <!-- 搜索 -->
    <div class="search">
      <el-form
        :model="exportForm"
        ref="exportForm"
        class="demo-ruleForm"
      >
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select
              v-model="exportForm.warehouseId"
              placeholder="请选择仓库"
              @change="changeWarehouse"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item prop="projectName" label="项目名称：">
              <el-select
                v-model="exportForm.projectName"
                placeholder="请选择项目"
                @change="changeProject"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="date" label="日期：">
              <el-date-picker
                v-model="exportForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item prop="checked" class="check">
            <el-checkbox v-model="exportForm.checked"
              >展示作废记录</el-checkbox
            >
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">收货数据信息</p>
      <div class="upload-return" @click="exportLoginForm('exportForm')">
        <span class="upload-return-img"></span>
        <span>导出</span>
      </div>
    </div>

    <!-- 收货列表 -->
    <div class="table">
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        :row-class-name="tableRowClassName"
        :header-cell-class-name="headerCellClassName"
      >
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 1" class="btn-text" type="text" @click="nullify(scope.row.id)"
              >作废</el-button
            >
            <el-button v-else class="btn-text nullify" type="text" disabled
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import ChargeRegister from "models/charge-register";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import PaginationTpl from "components/base/PaginationTpl";
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        customerId: '',
        projectName: '',
         // 1: 大宗出库; 2:退货服务; 3: 卸货服务; 4:增值服务
        serviceContent: 3,
        checked: false,
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '仓库名称', prop: 'warehouseName', width: '', alignment:'left'},
        {label: '项目名称', prop: 'projectName', width: '', alignment:'left'},
        {label: '日期', prop: 'creatTime', width: '150', alignment:'left'},
        {label: '数量', prop: 'nums', width: '', alignment:'right'},
        {label: '单价', prop: 'unitPrice', width: '', alignment:'right'},
        {label: '金额', prop: 'amount', width: '', alignment:'right'},
        {label: '备注', prop: 'remarks', width: '', alignment:'left'},
      ],
    }
  },

  created() {
    this.initWarehouse()
    this.initReceiptList()
  },

  methods: {
    /** 
     * @desc 初始化收货列表
    */
    initReceiptList() {
      let warehouseId	 = this.exportForm.warehouseId
      let beginDate = this.exportForm.date ?this.exportForm.date[0]:""
      let endDate = this.exportForm.date ?this.exportForm.date[1]:''
      let customerId	 = this.exportForm.customerId
      let projectId	 = this.exportForm.projectName
      let isCancel	 = this.exportForm.checked?1:0
      let currentPage	 = this.currentPage
      let data = {
        warehouseId,
        beginDate,
        endDate,
        customerId,
        projectId,
        isCancel,
        currentPage,
      }
      ChargeRegister.getChargeRecordUnloadingList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.unitPrice = numsToRMBSymbolAndMillimeter(value.unitPrice);
            obj.amount = numsToRMBSymbolAndMillimeter(value.checkPrice);
            obj.remarks = value.remarks;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    searchData() {
      this.currentPage = 1;
      this.initReceiptList();
    },
    
    reset() {
      this.exportForm.date = ""
      this.exportForm.warehouseId = ""
      this.exportForm.customerId = ""
      this.exportForm.projectName = ""
      this.exportForm.checked = false
    },

    /** 
     * @desc 作废
    */
    nullify(id) {
      this.$confirm("作废后，该收货单将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id
        }
        ChargeRegister.postNullify(data, this.exportForm.serviceContent).then(res => {
          if (res.success) {
            this.initReceiptList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },

    changeWarehouse() {
      let warehouseId = this.exportForm.warehouseId;
      this.initProjectListByWarehouse(warehouseId);
    },

    changeProject() {
      let obj = this.projectList.find(item => { return item.id == this.exportForm.projectName })
      this.exportForm.customerId = obj.customerId
    },
    
    /**
     * @desc 导出
     */
    exportLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId	 = this.exportForm.warehouseId
          let beginDate = this.exportForm.date ?this.exportForm.date[0]:''
          let endDate = this.exportForm.date ?this.exportForm.date[1]:''
          let customerId	 = this.exportForm.customerId
          let projectId	 = this.exportForm.projectName
          let isCancel	 = this.exportForm.checked?1:0
          let currentPage	 = this.currentPage
          let data = {
            warehouseId,
            beginDate,
            endDate,
            customerId,
            projectId,
            isCancel,
            currentPage,
          }
          ChargeRegister.getExport(data, this.exportForm.serviceContent).then((res) => {
            downLoadFileByBlob(res)
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @desc 为 Table 中的某一行添加 class
    */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 2 && columnIndex < 6) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initReceiptList();
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/receipt-list.scss";
</style>
